// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
import FlashTiming from '../forms/FlashTiming';
import MaxDisplaySpeed from '../forms/MaxDisplaySpeed';
import AutoDim from '../forms/AutoDim';
import Strobe from '../forms/Strobe';
import Beacon from '../forms/Beacon';
import Override from '../forms/Override';
import MiniDisplay from '../forms/MiniDisplay';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Advanced(props) {
  	const classes = useStyles();
	//inherited variables
  	const {sign, config, loadedToken, onChange} = props;
	//locally stored/copied variables
	const [token, setToken] = React.useState(0);
	const [cid, setCid] = React.useState(0);
	//local copy of config (shouldn't change parent except with onChange)
	const [myConfig, setMyConfig] = React.useState({
		id : 0,
		//messages
		messages: ['82', '6', '84', '84'],
		//display flash timing
		flashOnTime : 500,
		flashOffTime : 500,
		flashPeriod: 5,
		//Strobe timing
		strobeOnDelay: 500,
		strobeOnPeriod: 500,
		//auto dimming min/max
		dayDimSetting: 99,
		nightDimSetting: 10,
		//Max display speed
		maxTwoDisplaySpeed:99,
		//Master Override 
		speedLimit: 25,
		threshold: 25,
		maxDisplaySpeed: 35,
		dimming: 99,
		mode: 1,
		enable: 0,
		//not yet sure what these do
		master_enable_on: 1,
		master_enable_off: 1,
		master_enable_power: 1,
		//Beacons
		alternateEnable: true,
		wigOnPeriod: 500,
		wigOffPeriod: 0,
		wagOnPeriod: 500,
		wagOffPeriod: 0,
		beaconDimEnable: false,
		//Mini display timing
		mtimeOn: '500,500,500,500',
		mtimeOff: '500,500,500,500',
		loop_period: 80,
		ped_startFlash: 0, //on delay?
		ped_onPeriod: 4,
		daysettings: {},
		//Pixel maps
		pixel_maps:
		{
    "6": {
        "id": "6",
        "name": "default1",
        "description": "",
        "owner": ",1,",
        "parent": "0",
        "pixel_map": "000100010011100100010111100000,000100010100010100010100010000,000010100100010100010100010000,000001000100010100010100010000,000001000100010100010111100000,000001000100010100010101000000,000001000100010100010100100000,000001000100010100010100010000,000001000011100011100100010000,011100111100111110111110111100,100010100010100000100000100010,100000100010100000100000100010,100000100010100000100000100010,011100111100111100111100100010,000010100000100000100000100010,100010100000100000100000100010,100010100000100000100000100010,011100100000111110111110111100,",
        "organization": "3"
    },
    "82": {
        "id": "82",
        "name": "default0",
        "description": "",
        "owner": ",1,",
        "parent": "0",
        "pixel_map": "011100111100111110111110111100,100010100010100000100000100010,100000100010100000100000100010,100000100010100000100000100010,011100111100111100111100100010,000010100000100000100000100010,000010100000100000100000100010,100010100000100000100000100010,011100100000111110111110111100,100000111110100010111110111110,100000001000110110001000001000,100000001000101010001000001000,100000001000100010001000001000,100000001000100010001000001000,100000001000100010001000001000,100000001000100010001000001000,100000001000100010001000001000,111110111110100010111110001000,",
        "organization": "3"
    },
    "84": {
        "id": "84",
        "name": "default2",
        "description": "",
        "owner": ",1,",
        "parent": "0",
        "pixel_map": "000011100100000011100100010000,000100010100000100010100010000,000100000100000100010101010000,000100000100000100010101010000,000011100100000100010101010000,000000010100000100010101010000,000000010100000100010101010000,000100010100000100010101010000,000011100111110011100011100000,000111100011100100010100010000,000100010100010100010100010000,000100010100010101010110010000,000100010100010101010101010000,000100010100010101010100110000,000100010100010101010100010000,000100010100010101010100010000,000100010100010101010100010000,000111100011100011100100010000,",
        "organization": "3"
    }
}
	});
	
	//handle change flash timing
	const handleChangeFlashTiming = (timing) => {
		let newConfig = Object.assign({}, myConfig);
		newConfig.flashOnTime = timing.on;
		newConfig.flashOffTime = timing.off;
		newConfig.flashPeriod = timing.period;
		console.log(newConfig);
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//handle change max display speed
	const handleChangeMax = (newMax) => {
		let newConfig = Object.assign({}, myConfig);
		newConfig.maxTwoDisplaySpeed = newMax;
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//handle change auto dimming
	const handleChangeAutoDim = (day, night) => {
		let newConfig = Object.assign({}, myConfig);
		newConfig.dayDimSetting = day;
		newConfig.nightDimSetting = night;
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//handle change strobe
	const handleChangeStrobe = (delay, duration) => {
		let newConfig = Object.assign({}, myConfig);
		newConfig.strobeOnDelay = delay;
		newConfig.strobeOnPeriod = duration;
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//Handle change beacon
	const handleChangeBeacon = (timing, dim, alternate) => {
		let newConfig = Object.assign({}, myConfig);
		newConfig.alternateEnable = alternate;
		newConfig.wigOnPeriod = timing[0];
		newConfig.wigOffPeriod = timing[1];
		newConfig.wagOnPeriod = timing[2];
		newConfig.wagOffPeriod = timing[3];
		newConfig.beaconDimEnable = dim;
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//Handle changes in Override settings
	const handleChangeOverride = (input) => {
		//copy existing config state
		let newConfig = Object.assign({}, myConfig);
		//apply/overwrite new variables
		Object.assign(newConfig, {
			override: input.enable,
			speedLimit: input.speed,
			threshold: input.threshold,
			maxDisplaySpeed: input.maxDisplaySpeed,
			dimming: input.dim,
			mode: input.mode,
			enable: input.enable
		});
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//Handle changes to mini timing
	const handleChangeMini = (input) => {
		let newConfig = Object.assign({}, myConfig);
		Object.assign(newConfig, compileMiniTiming(input));
		setMyConfig(newConfig);
		handleConfigUpdate(newConfig);
	}
	
	//extract mini timing array from strings in config
	const extractMiniTiming = () => {
		let onTime = myConfig.mtimeOn.split(",");
		let offTime = myConfig.mtimeOff.split(",");
		let steps = [];
		for(var n = 0; n < 4; n++){
			steps.push([
				(isNaN(onTime[n]) ? 500 : onTime[n]), 
				(isNaN(offTime[n]) ? 500 : offTime[n])
			]);
		}
		return {steps: steps, duration: myConfig.loop_period / 10};
	}
	
	//compile mini on/off timing from array
	const compileMiniTiming = (timing) => {
		return ({
			mtimeOn : Array.from(timing.steps, x => x[0].toString()).join(','),
			mtimeOff : Array.from(timing.steps, x=> x[1].toString()).join(','),
			loop_period : timing.duration
		});
	}
	
	
	//update parent with changed config
	const handleConfigUpdate = (newConfig) => {
		let nconfig = newConfig || myConfig;
		if(nconfig.id !== 0 && nconfig.id !== '0'){
			if(onChange){
				console.log('updating parent');
				console.log(nconfig);
				onChange(nconfig);
			}
		}
	}
	
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== config.id 
			//updated from server
			|| loadedToken !== token
		) {
			setMyConfig(config);
			console.log('config has changed');
			console.log(config);
			setCid(config.id);
			setToken(loadedToken);
		}
		//console.log(config);
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	const hasOption = (name) => {
		if(sign){
			if(sign.options.length > 0){
				if(sign.options.findIndex(opt => opt.cfg_reference === name) !== -1)
					return true;
			}
		}
		return false;
	}
	
	const renderDim = () => {
		if(hasOption('autoDim'))
			return (
				<AutoDim id={cid} day={myConfig.dayDimSetting} night={myConfig.nightDimSetting} onChange={handleChangeAutoDim} />
			);
		return '';
	}
	
	const renderStrobe = () => {
		if(hasOption('strobe_enable'))
			return (
				<Strobe id={cid} sign={sign} delay={myConfig.strobeOnDelay} duration={myConfig.strobeOnPeriod} onChange={handleChangeStrobe} />
			);
		return '';
	}
	
	const renderBeacon = () => {
		if(hasOption('beaconEnable'))
			return (
				<Beacon id={cid} timing={[myConfig.wigOnPeriod, myConfig.wigOffPeriod, myConfig.wagOnPeriod, myConfig.wagOffPeriod]} dim={myConfig.beaconDimEnable} alternate={myConfig.alternateEnable} onChange={handleChangeBeacon} />
			);
		return '';
	}
	const renderMini = () => {
		//do they use mode 11 or 21?
		if(myConfig.daysettings){
			for(var dsid in myConfig.daysettings){
				if(myConfig.daysettings[dsid].op.default === 11 || myConfig.daysettings[dsid].op.default === 21)
					return (<MiniDisplay id={cid} timing={extractMiniTiming()} onChange={handleChangeMini} />);
				if(myConfig.daysettings[dsid].op.intervals.findIndex(op => op.value === 11 || op.value === 21) !== -1)
					return (<MiniDisplay id={cid} timing={extractMiniTiming()} onChange={handleChangeMini} />);
			}
		}
		return '';
		
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<div className={classes.root}>
			<Grid container justifyContent="space-around">
				<MaxDisplaySpeed id={cid} value={myConfig.maxTwoDisplaySpeed} onChange={handleChangeMax} />
				{renderDim()}
				{renderStrobe()}
				<FlashTiming id={cid} sign={sign} message={myConfig.pixel_maps[myConfig.messages[2]]} settings={{on:myConfig.flashOnTime, off:myConfig.flashOffTime, period:myConfig.flashPeriod}} onChange={handleChangeFlashTiming} />
				{renderBeacon()}
				<Override id={cid} sign={sign} config={myConfig} speed={myConfig.speedLimit} threshold={myConfig.threshold} maxspeed={myConfig.maxDisplaySpeed} dim={myConfig.dimming} mode={myConfig.mode} enable={myConfig.enable} onChange={handleChangeOverride} />
				{renderMini()}
			</Grid>
    	</div>
  );
}
